import { Box, Typography } from '@mui/material'
import React from 'react'
import { useAppSelector } from '../../../store/reducers/store'
import { Utilities } from '../../../utility/utils';
import { useTranslation } from 'react-i18next';

const FundFeesProvidedValues: React.FC = () => {
    const { t } = useTranslation();
    const portfolio = useAppSelector(state => state.createPortfolio.portfolio);
    return <Box display={"flex"} flexDirection={"column"} gap={"16px"}>
        <Box display={"flex"} justifyContent={"space-between"}>
            <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"400"}>{t('PortfolioPageItemManagementFee')}</Typography>
            <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"600"}>{portfolio.managementFees ? Utilities.round(portfolio.managementFees * 100, 2) : 0}%</Typography>
        </Box>
        <Box display={"flex"} justifyContent={"space-between"}>
            <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"400"}>{t('PortfolioPageItemCarryFee')}</Typography>
            <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"600"}>{portfolio.carryFees ? Utilities.round(portfolio.carryFees * 100, 2) : 0}%</Typography>
        </Box>
        <Box display={"flex"} justifyContent={"space-between"}>
            <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"400"}>{t('CreatePortfolioExpectedPortfolioLife')}</Typography>
            <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"600"}>{portfolio.portfolioLife}</Typography>
        </Box>
        <Box display={"flex"} justifyContent={"space-between"}>
            <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"400"}>{t('CreatePortfolioMultipleAtPortfolioExit')}</Typography>
            <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"600"}>{portfolio.multipleAtExit ? Utilities.round(portfolio.multipleAtExit, 2) : 0}</Typography>
        </Box>
    </Box>
}

export default FundFeesProvidedValues